export default __webpack_public_path__ + "static/media/header.c0c8bf57.jpeg";